import React, { useState, useRef } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TableRow, Table, TableHead, TableBody, TableCell, FormControl, InputLabel, MenuItem, Select, TableContainer, Paper, Checkbox, ListItemText } from "@material-ui/core";
import TrainerService from "./Locality/Service/trainerService";
import ChunkedUploadService from "./Locality/Service/chunkedUploadService";
import * as Yup from 'yup';

import { Grid, TextField } from "@material-ui/core";
import { useFormik } from 'formik';
import { useEffect } from 'react';
import DeleteIcon from '@material-ui/icons/Delete';

import EditIcon from '@material-ui/icons/Edit';
import Widget from "../../components/Widget/Widget";
import PageTitle from "../../components/PageTitle/PageTitle";
import { withStyles, makeStyles } from '@material-ui/core/styles';
import AddClassService from "./Locality/Service/addClassService";
import TrainerRegistrationService from "./Locality/Service/trainerRegistrationService";
import { showAppConfirm } from '../../context/AlertContext';
const normalizeMediaUrls = (urls) => {
    if (Array.isArray(urls)) {
        return urls.map((u) => String(u || '').trim()).filter(Boolean);
    }
    if (urls && typeof urls === 'string' && urls.trim() !== '') {
        return [urls.trim()];
    }
    return [];
};

const toMediaPayload = (urls) => {
    const list = normalizeMediaUrls(urls);
    if (list.length === 0) return undefined;
    return list.length === 1 ? list[0] : list;
};

const notifyTrainingSessionsUpdated = () => {
    window.dispatchEvent(new CustomEvent('trainingSessionsUpdated'));
};

const getTrainerClassNames = (trainer) => {
    if (Array.isArray(trainer.classIds) && trainer.classIds.length) {
        return trainer.classIds
            .map((c) => (typeof c === 'object' && c !== null ? c.className : c))
            .filter(Boolean)
            .join(', ');
    }
    return trainer.classId?.className || '';
};

const resolveTrainerClassIds = (trainerData) => {
    if (Array.isArray(trainerData.classIds) && trainerData.classIds.length) {
        return trainerData.classIds.map((c) => (typeof c === 'object' && c !== null ? c._id : c)).filter(Boolean);
    }
    const single = trainerData.classId?._id || trainerData.classId;
    return single ? [single] : [];
};

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#0f3b62ad",
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);
const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
}));
export default function Trainer() {
    const tableHeaders = [ ' Name', 'Class', 'Subject',  'Date', 'Status', 'Edit', 'Delete'];
    const classes = useStyles();
    const [trainerList, setTrainerList] = useState([]);
    const [age, setAge] = React.useState('');
    const [trainerIdList, setTrainerIdList] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [imageslist, setImagesList] = useState([]);
    const [imageslist1, setImagesList1] = useState([]);
    const [imageslist2, setImagesList2] = useState([]);
    var [error, setError] = useState(null);

    var [classId, setClassId] = useState("");
    const [trainerRegisterList, setTrainerRegistrationList] = useState([]);

    const [message, setMessage] = useState("");
    const [message1, setMessage1] = useState("");
    const [message2, setMessage2] = useState("");
    const [uploadingVideo, setUploadingVideo] = useState(false);
    const [uploadingAudio, setUploadingAudio] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [uploadStatus, setUploadStatus] = useState("");

    const [images, setImages] = useState([]);
    const [images1, setImages1] = useState([]);
    const [images2, setImages2] = useState([]);

    // Refs for file inputs to clear them
    const audioFileInputRef = useRef(null);
    const videoFileInputRef = useRef(null);
    const profileFileInputRef = useRef(null);

    // Chunk size: 5MB (adjust as needed)
    const CHUNK_SIZE = 5 * 1024 * 1024; // 5MB in bytes

    const [trainer, setTrainer] = useState({
        // name: '',
        subject: '',
        // mobileNumber: '',
        // imageURL: '',
        // profileURL: '',

        trainerRegisterId: '',
        // date: '',
        classIds: [],
        // email: "",
        status: true, // Default to Active
    })

    var [searchClassId, setSearchClassId] = useState("");

    const [isEditMode, setIsEditMode] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [addClassList, setAddClassList] = useState([]);
    const validationSchema = Yup.object().shape({
        // date: Yup.string().required(' required'),
        trainerRegisterId: Yup.string().required(' required'),
        classIds: Yup.array().min(1, 'At least one class is required'),
        status: Yup.string().required(' required'),
        subject: Yup.string().required(' required'),
        // subject: Yup.string().required(' required'),
        // status: Yup.string().required(' required'),
     
    });
    useEffect(() => {
        getTrainerList();
        getAddClassList();
        getTrainerRegistrationList();
        return () => {
            setTrainerIdList([]);
            setTrainerList([]);
            setTrainerRegistrationList([]);
        }
    }, []);
    const handleOpen = (status) => {
        if (status) {
            setTrainer({
                // name: '',
                 subject: '',
                // mobileNumber: '',
                trainerRegisterId: '',
                //  date: '',
                classIds: [],
                // email: "",
                 status: true, // Default to Active
            })
            setMessage("");
            setMessage1("");
            setMessage2("");
            setUploadingVideo(false);
            setUploadingAudio(false);
            setUploadProgress(0);
            setUploadStatus("");
            // Clear image lists when adding new item
            setImagesList([]);
            setImagesList1([]);
            setImagesList2([]);
            setImages([]);
            setImages1([]);
            setImages2([]);
            // Clear file inputs
            if (audioFileInputRef.current) audioFileInputRef.current.value = '';
            if (videoFileInputRef.current) videoFileInputRef.current.value = '';
            if (profileFileInputRef.current) profileFileInputRef.current.value = '';
        }

        setOpen(true);
    };
    const verifyeetnt = () => {
        console.log(formik)
    }
    const handleClose = () => {
        setOpen(false);
        setMessage("");
        setMessage1("");
        setMessage2("");
        setUploadingVideo(false);
        setUploadingAudio(false);
        setUploadProgress(0);
        setUploadStatus("");
        // Clear image lists when closing dialog
        setImagesList([]);
        setImagesList1([]);
        setImagesList2([]);
        setImages([]);
        setImages1([]);
        setImages2([]);
        // Clear file inputs
        if (audioFileInputRef.current) audioFileInputRef.current.value = '';
        if (videoFileInputRef.current) videoFileInputRef.current.value = '';
        if (profileFileInputRef.current) profileFileInputRef.current.value = '';
    };

    // Helper function to split file into chunks
    const splitFileIntoChunks = (file, chunkSize) => {
        const chunks = [];
        let start = 0;
        let chunkIndex = 0;

        while (start < file.size) {
            const end = Math.min(start + chunkSize, file.size);
            const chunk = file.slice(start, end);
            chunks.push({
                chunk,
                chunkIndex,
                start,
                end,
                size: chunk.size
            });
            start = end;
            chunkIndex++;
        }

        return chunks;
    };

    // Chunked upload function with retry logic
    const uploadFileInChunks = async (file, fileType = 'video') => {
        let uploadId = null;
        try {
            // Initialize upload session
            const initResponse = await ChunkedUploadService.initializeChunkUpload({
                fileName: file.name,
                fileSize: file.size,
                totalChunks: Math.ceil(file.size / CHUNK_SIZE),
                fileType: fileType
            });

            uploadId = initResponse.uploadId;

            // Split file into chunks
            const chunks = splitFileIntoChunks(file, CHUNK_SIZE);
            const totalChunks = chunks.length;

            setUploadStatus(`Initializing upload (${totalChunks} chunks)...`);

            // Upload each chunk sequentially with retry logic
            for (let i = 0; i < chunks.length; i++) {
                const chunkData = chunks[i];
                const formData = new FormData();
                formData.append('chunk', chunkData.chunk);
                formData.append('uploadId', uploadId);
                formData.append('chunkIndex', chunkData.chunkIndex);
                formData.append('totalChunks', totalChunks);

                setUploadStatus(`Uploading chunk ${i + 1} of ${totalChunks}...`);
                
                // Retry logic for chunk upload
                let retryCount = 0;
                const maxRetries = 3;
                let chunkUploaded = false;

                while (retryCount < maxRetries && !chunkUploaded) {
                    try {
                        await ChunkedUploadService.uploadChunk(formData);
                        chunkUploaded = true;
                    } catch (chunkError) {
                        retryCount++;
                        if (retryCount >= maxRetries) {
                            throw new Error(`Failed to upload chunk ${i + 1} after ${maxRetries} attempts: ${chunkError.message}`);
                        }
                        // Wait before retry (exponential backoff)
                        const retryDelayMs = 1000 * retryCount;
                        await new Promise(resolve => setTimeout(resolve, retryDelayMs));
                        setUploadStatus(`Retrying chunk ${i + 1} (attempt ${retryCount + 1}/${maxRetries})...`);
                    }
                }

                // Update progress
                const progress = Math.round(((i + 1) / totalChunks) * 100);
                setUploadProgress(progress);
            }

            // Complete the upload with retry logic
            setUploadStatus("Finalizing upload...");
            let completeResponse;
            let retryCount = 0;
            const maxRetries = 3;

            while (retryCount < maxRetries) {
                try {
                    completeResponse = await ChunkedUploadService.completeChunkUpload({ uploadId });
                    break;
                } catch (completeError) {
                    retryCount++;
                    if (retryCount >= maxRetries) {
                        throw new Error(`Failed to complete upload after ${maxRetries} attempts: ${completeError.message}`);
                    }
                    // Wait before retry
                    const finalizeDelayMs = 2000 * retryCount;
                    await new Promise(resolve => setTimeout(resolve, finalizeDelayMs));
                    setUploadStatus(`Retrying finalization (attempt ${retryCount + 1}/${maxRetries})...`);
                }
            }

            setUploadProgress(100);
            setUploadStatus("Upload completed successfully!");

            return completeResponse.url;
        } catch (error) {
            console.error("Error in chunked upload:", error);
            // Try to cancel the upload session on error if we have uploadId
            if (uploadId) {
                try {
                    await ChunkedUploadService.cancelUploadSession({ uploadId });
                } catch (cancelError) {
                    console.error("Error cancelling upload session:", cancelError);
                }
            }
            throw error;
        }
    };
    const handleFileChange = (e) => {
        setImages(e.target.files); // Store all selected files in state
    };
    const handleFileChange1 = (e) => {
        setImages1(e.target.files); // Store all selected files in state
    };
    const handleFileChange2 = (e) => {
        setImages2(e.target.files); // Store all selected files in state
    };
    const handleClickShowPassword = () => {
        setShowPassword((prev) => !prev);
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };
    const getAddClassList = (event) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        AddClassService.getAllAddClass(userDetails.schooleId).then((res) => {
            if (userDetails.role === "TEACHER") {
                res = res.filter(res => res._id === userDetails.classId);
            }
            setAddClassList(res);
            if (userDetails.classId) {
                setClassId(userDetails.classId);
            } else {
                setClassId(""); // No default selection
            }
        }).catch((err) => {
            // setError(err.message);
        });
    }
    const dateAndTime = (date) => {

        const systemDate = new Date(date);
        const formattedDateTime = systemDate.toLocaleString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            // hour: 'numeric',
            // minute: 'numeric',
            // second: 'numeric',
            // hour12: true,

        });
        return formattedDateTime;
    }
    const getTrainerList = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        TrainerService.getAllTrainer(userDetails.schooleId).then((res) => {
            const mapResult = res.map((trainer) => {
                return { ...trainer }
            })
            setTrainerList(mapResult);

        }).catch((err) => {
            // setError(err.message);
        });
    }
    const onSubmit = data => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));

        const keys = {
            'classId': searchClassId,
        }
        TrainerService.findTrainerList(keys).then((res) => {

            const mapResult = res.map((trainer) => {
                return { ...trainer }
            })
            setTrainerList(mapResult);
            // setStudentList(res);
        }).catch((err) => {
            console.error(err)
            // setError(err.message);
        });

    };
   

    // const editTrainer = (trainer) => {
    //     setTrainer(trainer);
    //     handleOpen(false);

    // };
       
    const editTrainer = (trainerData) => {
    setTrainer({
        _id: trainerData._id || '',
        name: trainerData.name || '',
        subject: trainerData.subject || '',
        mobileNumber: trainerData.mobileNumber || '',
        email: trainerData.email || '',
trainerRegisterId: trainerData.trainerRegisterId?._id || trainerData.trainerRegisterId || '',
        classIds: resolveTrainerClassIds(trainerData),
        
        status: trainerData.status || '',
        profile: trainerData.profile || '',
        imageURL: trainerData.imageURL || '',
        profileURL: trainerData.profileURL || '',
    });

    // Set preview URLs for files - handle both array and string formats
    // videoURL can be an array or a string
    let videoUrls = [];
    if (Array.isArray(trainerData.videoURL)) {
        videoUrls = trainerData.videoURL.length > 0 ? trainerData.videoURL : [];
    } else if (trainerData.videoURL && typeof trainerData.videoURL === 'string') {
        videoUrls = [trainerData.videoURL];
    }
    setImagesList(videoUrls);

    // audioURL can be an array or a string - only show if array length > 0
    let audioUrls = [];
    if (Array.isArray(trainerData.audioURL)) {
        audioUrls = trainerData.audioURL.length > 0 ? trainerData.audioURL : [];
    } else if (trainerData.audioURL && typeof trainerData.audioURL === 'string') {
        audioUrls = [trainerData.audioURL];
    }
    setImagesList1(audioUrls);

    setImagesList2(trainerData.profile ? [trainerData.profile] : []);

    handleOpen(false);
};


    const deleteTrainer = async (trainerdelete) => {
        if (trainerdelete) {
            // Confirm deletion
            const confirmDelete = await showAppConfirm(
                "Are you sure you want to delete this training topic? This will also delete all associated video and audio files from Azure storage."
            );
            
            if (!confirmDelete) {
                return;
            }

            try {
                // Delete video files from Azure
                if (trainerdelete.videoURL) {
                    const videoUrls = Array.isArray(trainerdelete.videoURL) 
                        ? trainerdelete.videoURL 
                        : [trainerdelete.videoURL];
                    
                    for (const videoUrl of videoUrls) {
                        if (videoUrl && videoUrl.trim() !== '') {
                            try {
                                await ChunkedUploadService.deleteFileByUrl({ fileUrl: videoUrl });
                                console.log('Video deleted from Azure:', videoUrl);
                            } catch (videoError) {
                                console.error('Error deleting video from Azure:', videoUrl, videoError);
                                // Continue with deletion even if Azure delete fails
                            }
                        }
                    }
                }

                // Delete audio files from Azure
                if (trainerdelete.audioURL) {
                    const audioUrls = Array.isArray(trainerdelete.audioURL) 
                        ? trainerdelete.audioURL 
                        : [trainerdelete.audioURL];
                    
                    for (const audioUrl of audioUrls) {
                        if (audioUrl && audioUrl.trim() !== '') {
                            try {
                                await ChunkedUploadService.deleteFileByUrl({ fileUrl: audioUrl });
                                console.log('Audio deleted from Azure:', audioUrl);
                            } catch (audioError) {
                                console.error('Error deleting audio from Azure:', audioUrl, audioError);
                                // Continue with deletion even if Azure delete fails
                            }
                        }
                    }
                }

                // Delete trainer record from database
                await TrainerService.deleteTrainer(trainerdelete);
                getTrainerList();
                notifyTrainingSessionsUpdated();
                alert("Trainer and associated files deleted successfully.");
            } catch (err) {
                console.error('Error deleting trainer:', err);
                alert("Error deleting trainer. Please try again.");
            }
        }
    };
    const handleUpload = async (e) => {
        e.preventDefault();

        if (images.length === 0) {
            setMessage("Please select video files first.");
            return;
        }
        setUploadingVideo(true);
        setUploadProgress(0);
        setMessage("Preparing upload...");
        
        try {
            const uploadedUrls = [];

            for (const videoFile of images) {
                try {
                    // Always use chunked upload for all video files via chunkedUploadController and router
                    setMessage(`Uploading video file (${(videoFile.size / (1024 * 1024)).toFixed(2)} MB) using chunked upload...`);
                    const url = await uploadFileInChunks(videoFile, 'video');
                    
                    uploadedUrls.push(url);
                    setMessage(`Video uploaded successfully! (${uploadedUrls.length}/${images.length})`);
                } catch (error) {
                    console.error(`Error uploading video file ${videoFile.name}:`, error);
                    const errorMsg = error.response?.data?.error || error.message || "An error occurred while uploading the video.";
                    setMessage(`Error uploading ${videoFile.name}: ${errorMsg}`);
                    throw error;
                }
            }
            
            setImagesList((prev) => [...prev, ...uploadedUrls]); // Add to array
            setMessage("All videos uploaded successfully!");
            setUploadingVideo(false);
            setUploadProgress(0);
            setUploadStatus("");
            setImages([]); // Clear selected files after upload
        } catch (error) {
            console.error("Error uploading videos:", error);
            const errorMsg = error.response?.data?.error || error.message || "An error occurred while uploading the video.";
            setMessage(`Upload failed: ${errorMsg}`);
            setUploadingVideo(false);
            setUploadProgress(0);
            setUploadStatus("");
        }
    };
    const handleUpload1 = async (e) => {
        e.preventDefault();

        if (images1.length === 0) {
            setMessage1("Please select audio files first.");
            return;
        }
        setUploadingAudio(true);
        setMessage1("Uploading audio...");
        try {
            const uploadedUrls = [];

            for (const image of images1) {
                const formData = new FormData();
                formData.append("image", image);
                formData.append("imageName", image.name);

                const res = await TrainerService.uploadImage(formData);
                uploadedUrls.push(res.url); // Assuming response contains the uploaded URL
            }
            setImagesList1((prev) => [...prev, ...uploadedUrls]); // Add to array
            setMessage1("Audio uploaded successfully!");
            setUploadingAudio(false);
            setImages1([]); // Clear selected files after upload
        } catch (error) {
            console.error("Error uploading images:", error);
            setMessage1("An error occurred while uploading the audio.");
            setUploadingAudio(false);
        }
        // Create FormData and append each file
        // const formData = new FormData();
        // if (images1.length > 0) {
        //     const image = images1[0];
        //     formData.append(`image`, image);

        //     formData.append(`imageName`, image.name);
        //     // images.forEach((image, index) => {
        //     //   formData.append(`images`, image); // Append each file to the form
        //     // });

        //     try {
        //         // Send the images to the API
        //         TrainerService.uploadImage(formData).then((res) => {

        //             alert(` uploaded successfully`);
        //             setImagesList1(res.url);


        //         }).catch((err) => {
        //             alert(err.message);
        //         });
        //     } catch (error) {
        //         console.error("Error uploading images:", error);
        //         setMessage("An error occurred while uploading the images.");
        //     }
        // }

    };
    const handleUpload2 = async (e) => {
        e.preventDefault();

        if (images2.length === 0) {
            setMessage2("Please select images first.");
            return;
        }
        try {
            const uploadedUrls = [];

            for (const image of images2) {
                const formData = new FormData();
                formData.append("image", image);
                formData.append("imageName", image.name);

                const res = await TrainerService.uploadImage(formData);
                uploadedUrls.push(res.url); // Assuming response contains the uploaded URL
            }
            setImagesList2((prev) => [...prev, ...uploadedUrls]); // Add to array
            alert(" uploaded successfully");
        } catch (error) {
            console.error("Error uploading images:", error);
            setMessage1("An error occurred while uploading the images.");
        }


    };
    const getTrainerRegistrationList = () => {

        TrainerRegistrationService.getAllTrainerRegistration().then((res) => {

            setTrainerRegistrationList(res);
        }).catch((err) => {
            setError(err.message);
        });
    }
    const removeImage = (index, imageURL) => {
        TrainerService.deleteAzureImage({ "imageURL": imageURL }).then((res) => {
            const updatedList = [...imageslist1];
            updatedList.splice(index, 1);
            setImagesList(updatedList);
        }).catch((err) => {
        });
    };
    const formik = useFormik({
        initialValues: trainer,
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values, { resetForm }) => {
            const userDetails = JSON.parse(localStorage.getItem("userDetail"));
            values.schooleId = userDetails.schooleId;
            const videoPayload = toMediaPayload(imageslist);
            const audioPayload = toMediaPayload(imageslist1);
            if (videoPayload !== undefined) {
                values.videoURL = videoPayload;
            }
            if (audioPayload !== undefined) {
                values.audioURL = audioPayload;
            }

            if (trainer._id) {
                TrainerService.upadeTrainer(values).then((res) => {
                    handleClose();
                    getTrainerList();
                    notifyTrainingSessionsUpdated();
                    resetForm()
                    alert("Trainer Updated Successfully.");
                    setImagesList([])
                }).catch((err) => {
                });
            }
            else {
                TrainerService.creteTrainer(values).then((res) => {
                    getTrainerList();
                    notifyTrainingSessionsUpdated();
                    resetForm();
                    handleClose();
                    alert(" Trainer Added Successfully.");
                    // props.history.push('/app/vendor');
                })
                    .catch((err) => {
                        alert(err.response.data.message)
                    })
            }

        },
    });

    return (

        <>
            <PageTitle title="Trainer" button={<Button
                variant="contained" onClick={() => handleOpen(true)}
                size="medium"
                color="secondary" style={{ backgroundColor: 'rgb(15 59 98)' }}> Add Training Topic
            </Button>} />

            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <Widget title="" upperTitle noBodyPadding bodyClass={classes.tableOverflow}>
                                                <TableContainer component={Paper} style={{ maxHeight: 500 }}>

                        <Table stickyHeader className="mb-0">
                            <TableHead >
                                <TableRow>
                                    {tableHeaders.map(key => (
                                        <StyledTableCell key={key}>{key}</StyledTableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {trainerList.map((trainer) => (
                                    <TableRow key={trainer._id}>
                                        
                                        <TableCell className="pl-3 fw-normal" >{trainer.trainerRegisterId ? trainer.trainerRegisterId.name : ''}</TableCell>
                                        
                                        <TableCell className="pl-3 fw-normal" >{getTrainerClassNames(trainer)}</TableCell>
                                        <TableCell className="pl-3 fw-normal" >{trainer.subject}</TableCell>
                                        

                                        {/* <TableCell className="pl-3 fw-normal" >{trainer.date}</TableCell> */}
                                        <TableCell className="pl-3 fw-normal">{dateAndTime(trainer.createdAt)}</TableCell>

                                        <TableCell>
                                            {trainer.status ? 'Active' : 'In Active'}
                                        </TableCell>

                                        <TableCell>
                                            <EditIcon style={{ cursor: 'pointer' }} onClick={() => editTrainer(trainer)} >
                                            </EditIcon >
                                        </TableCell>
                                        <TableCell>
                                            <DeleteIcon style={{ cursor: 'pointer' }} onClick={() => deleteTrainer(trainer)} />
                                        </TableCell>

                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                        </TableContainer>
                    </Widget>
                </Grid>
            </Grid>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Add Training Topic</DialogTitle>
                <form onSubmit={formik.handleSubmit} >
                    <DialogContent style={{ width: 308 }}>

                        <FormControl className={classes.formControl} fullWidth="true"
                        >
                            <InputLabel id="demo-simple-select-label">Select Trainer</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"

                                name="trainerRegisterId"
                                label="select Trainer"
                                value={formik.values.trainerRegisterId}
                                onChange={formik.handleChange}
                                error={formik.touched.trainerRegisterId && Boolean(formik.errors.trainerRegisterId)}
                                helperText={formik.touched.trainerRegisterId && formik.errors.trainerRegisterId}
                            >
                                <MenuItem value="">
                                    <em>None</em>
                                </MenuItem>

                                {trainerRegisterList.map(({ _id, name }) => (
                                    <MenuItem key={_id} value={_id}>{name}

                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl className={classes.formControl} fullWidth="true"
                        >
                            <InputLabel id="trainer-class-multi-label">Select Class</InputLabel>
                            <Select
                                labelId="trainer-class-multi-label"
                                id="trainer-class-multi"
                                multiple
                                name="classIds"
                                label="Select Class"
                                value={formik.values.classIds}
                                onChange={(e) => {
                                    formik.setFieldValue('classIds', e.target.value);
                                    formik.setFieldTouched('classIds', true);
                                }}
                                renderValue={(selected) => {
                                    const names = addClassList
                                        .filter((c) => selected.includes(c._id))
                                        .map((c) => c.className);
                                    return names.join(', ');
                                }}
                                error={formik.touched.classIds && Boolean(formik.errors.classIds)}
                            >
                                {addClassList.map(({ _id, className }) => (
                                    <MenuItem key={_id} value={_id}>
                                        <Checkbox checked={formik.values.classIds.indexOf(_id) > -1} />
                                        <ListItemText primary={className} />
                                    </MenuItem>
                                ))}
                            </Select>
                            {formik.touched.classIds && formik.errors.classIds && (
                                <span style={{ color: '#f44336', fontSize: 12, marginTop: 4 }}>
                                    {formik.errors.classIds}
                                </span>
                            )}
                        </FormControl>
                        <TextField
                            InputProps={{ style: { width: 258 } }}
                            margin="dense"
                            id="subject"
                            name="subject"
                            label="Subject"
                            type="text"
                            variant="standard"
                            value={formik.values.subject}
                            onChange={formik.handleChange}
                            error={formik.touched.subject && Boolean(formik.errors.subject)}
                            helperText={formik.touched.subject && formik.errors.subject}
                        />


                        <FormControl variant="standard" fullWidth>
                            <InputLabel id="demo-simple-select-standard-label">Status</InputLabel>
                            <Select
                                labelId="demo-simple-select-standard-label"
                                id="demo-simple-select-standard"
                                label="status"
                                name="status"
                                value={formik.values.status}
                                onChange={formik.handleChange}
                                error={formik.touched.status && Boolean(formik.errors.status)}
                                helperText={formik.touched.status && formik.errors.status}
                            >
                                <MenuItem value="">
                                    <em>None</em>
                                </MenuItem>
                                <MenuItem value={true}>Active</MenuItem>
                                <MenuItem value={false}>In Active</MenuItem>
                            </Select>
                        </FormControl>
                        <br></br>
                        <br></br>
                        <Grid item xs={12} style={{ marginTop: '30px' }}>
                            <span style={{ fontSize: '17px', color: '#0f3b62ad', }} >Uplaod Audio:</span>
                        </Grid>
                        <Grid item xs={6}>
                            <input
                                ref={audioFileInputRef}
                                type="file"
                                accept="audio/*"
                                onChange={handleFileChange1}
                                disabled={uploadingAudio}
                            />
                            <br></br>
                            <br></br>
                            <Button 
                                style={{ backgroundColor: 'rgb(15 59 98)', color: 'white', border: 'none' }} 
                                onClick={handleUpload1}
                                disabled={uploadingAudio}
                            >
                                {uploadingAudio ? 'Uploading...' : 'Upload'}
                            </Button>
                            {message1 && (
                                <div style={{ 
                                    marginTop: '10px', 
                                    color: message1.includes('error') || message1.includes('Error') ? 'red' : message1.includes('successfully') ? 'green' : '#0f3b62ad',
                                    fontSize: '14px',
                                    fontWeight: '500'
                                }}>
                                    {message1}
                                </div>
                            )}

                            {imageslist1?.length > 0 && (
                                <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
                                    {imageslist1?.map((url, index) => (
                                        <div key={index} style={{ position: 'relative' }}>

                                            <audio controls style={{ width: "200px" }}>
                                                <source src={url} type="audio/mpeg" />
                                                Your browser does not support the audio element.
                                            </audio>
                                            <Button
                                                size="small"
                                                onClick={() =>
                                                    setImagesList1((prev) => prev.filter((_, i) => i !== index))
                                                }
                                                style={{
                                                    position: "absolute",
                                                    top: 0,
                                                    right: 0,
                                                    backgroundColor: "white",
                                                    border: "none",
                                                    cursor: "pointer",
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                ❌
                                            </Button>
                                        </div>

                                    ))}
                                </div>
                            )}
                        </Grid>

                        <Grid item xs={12} style={{ marginTop: '30px' }}>
                            <span style={{ fontSize: '17px', color: '#0f3b62ad', }} >Uplaod Video:</span>
                        </Grid>
                        <Grid item xs={6}>
                            <input
                                ref={videoFileInputRef}
                                type="file"
                                accept="video/*"
                                onChange={handleFileChange}
                                disabled={uploadingVideo}
                            />
                            <br></br>
                            <br></br>
                            <Button 
                                style={{ backgroundColor: 'rgb(15 59 98)', color: 'white', border: 'none' }} 
                                onClick={handleUpload}
                                disabled={uploadingVideo}
                            >
                                {uploadingVideo ? 'Uploading...' : 'Upload'}
                            </Button>
                            
                            {/* Progress Bar */}
                            {uploadingVideo && uploadProgress > 0 && (
                                <div style={{ marginTop: '15px', width: '100%' }}>
                                    <div style={{ 
                                        width: '100%', 
                                        backgroundColor: '#e0e0e0', 
                                        borderRadius: '4px', 
                                        height: '20px',
                                        overflow: 'hidden',
                                        marginBottom: '5px'
                                    }}>
                                        <div style={{
                                            width: `${uploadProgress}%`,
                                            backgroundColor: uploadProgress === 100 ? '#4caf50' : '#0f3b62ad',
                                            height: '100%',
                                            transition: 'width 0.3s ease',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            color: 'white',
                                            fontSize: '12px',
                                            fontWeight: 'bold'
                                        }}>
                                            {uploadProgress}%
                                        </div>
                                    </div>
                                </div>
                            )}
                            
                            {/* Status Messages */}
                            {message && (
                                <div style={{ 
                                    marginTop: '10px', 
                                    color: message.includes('error') || message.includes('Error') || message.includes('failed') ? 'red' : message.includes('successfully') ? 'green' : '#0f3b62ad',
                                    fontSize: '14px',
                                    fontWeight: '500'
                                }}>
                                    {message}
                                </div>
                            )}
                            {uploadStatus && (
                                <div style={{ 
                                    marginTop: '5px', 
                                    color: '#666',
                                    fontSize: '12px',
                                    fontStyle: 'italic'
                                }}>
                                    {uploadStatus}
                                </div>
                            )}

                            {imageslist.length > 0 && (
                                <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
                                    {imageslist.map((url, index) => (
                                        <div key={index} style={{ position: 'relative' }}>

                                            <video width="200" height="120" controls>
                                                <source src={url} type="video/mp4" />
                                                Your browser does not support the video tag.
                                            </video>
                                            <Button
                                                size="small"
                                                onClick={() =>
                                                    setImagesList((prev) => prev.filter((_, i) => i !== index))
                                                }
                                                style={{
                                                    position: "absolute",
                                                    top: 0,
                                                    right: 0,
                                                    backgroundColor: "white",
                                                    border: "none",
                                                    cursor: "pointer",
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                ❌
                                            </Button>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </Grid>



                    </DialogContent>

                    <DialogActions>
                        <Button onClick={handleClose}>Cancel</Button>
                        <Button type="submit" onClick={verifyeetnt}>Add</Button>
                    </DialogActions>
                </form>
            </Dialog>
        </>
    );
}


